import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { ProjectsService } from '@zayan-erp/home-building';
import { Project } from '@zayan-erp/home-building';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalService } from '@zayan-erp/shared';

@Component({
  selector: 'app-project-info-popup',
  standalone: true,
  imports: [SvgIconsComponent],
  templateUrl: './project-info-popup.component.html'
})
export class ProjectInfoPopupComponent {
  @Input() projectId!: string;
  _modalService = inject(NgbModal);
  _ngbModalService = inject(NgbModalService);
  @ViewChild('projectInfoModal') projectInfoModal!: ElementRef;

  #projService = inject(ProjectsService);
  selectedProjectInfo: Project | null = null;
  isOpen = false;

  openModal(): void {
    if (this.projectId) {
      this.#projService.getProjectById(this.projectId).subscribe((project: Project) => {
        this.selectedProjectInfo = project;
        this._modalService.open(this.projectInfoModal, {
          ...this._ngbModalService.centerModal,
          size: 'lg'
        });
      });
    }
  }
}
